import React from 'react'
import { useSelector } from 'react-redux'
import { Spinner } from '@shopify/polaris'
import _ from 'lodash'
import CreditsHeader from './components/CreditsHeader'
import CreditsList from './components/CreditsList'

/**
 * CreditsComponent - Displays user credits
 *
 * Features:
 * - Shows loading state while fetching credits
 * - Displays list of credits with count
 * - Hides component if no credits and not loading
 * - Supports multiple credit types
 */
const CreditsComponent = () => {
	const credits = useSelector((state) => state.dashboard.credits)
	const fetchingCredits = useSelector((state) => state.dashboard.fetchingCredits)

	// Don't render anything if no credits and not loading
	if (!fetchingCredits && _.isEmpty(credits)) {
		return null
	}

	return (
			<div
					className='block-white'
					style={{marginTop: 20}}
			>
				{fetchingCredits ? (
						<Spinner />
				) : (
						<>
							<CreditsHeader />
							<br />
							<CreditsList credits={credits} />
						</>
				)}
			</div >
	)
}

export default CreditsComponent

